<template>
  <div class="goodCourse">
    <div class="goodCourseBox">
      <div class="goodCourseHead">
        <img
          src="https://wowsite.oss-cn-shenzhen.aliyuncs.com/public/uploads/course/helphead.png"
          alt=""
        />
      </div>
      <div class="centent">
        <div class="goodCoursejpb">
          <div class="jpCourse" v-for="(item, index) in jpkdata">
            <div class="jpCouseSm" @click="goexternal(item)">
              <div class="jpcover">
                <img :src="item.course.cover_image_url" alt="" />
              </div>
              <div class="jpcontent">
                <div class="jptitle">{{ item.course.title }}</div>
                <div class="jpPirce">
                  <div>助力价 ￥{{ item.course.price }}</div>
                </div>
                <div class="buynow">助力领取</div>
              </div>
            </div>
          </div>
        </div>
        <div class="qa">
          <div class="qabigtitle">助力小技巧</div>
          <div class="qasm">
            <div class="Qbox">
              <div class="q">1</div>
              <div class="qtext">分享给多个好友可增加助力成功机会；</div>
            </div>
          </div>
          <div class="qasm">
            <div class="Qbox">
              <div class="q">2</div>
              <div class="qtext">
                在规定时间内达到助力人数，即可获得购课优惠；
              </div>
            </div>
          </div>
          <div class="qasm">
            <div class="Qbox">
              <div class="q">3</div>
              <div class="qtext">
                每位好友每个课程可为你助力1次，不同课程每天最多可为你助力3次；
              </div>
            </div>
          </div>
          <div class="qasm">
            <div class="Qbox">
              <div class="q">4</div>
              <div class="qtext">
                助力成功可获得以上助力价购课，请在活动结束24小时内尽快购课使用哦，如果已退出活动页面，可以在音乐窝教育小程序>我的>我的助力进入助力活动页面。
              </div>
            </div>
          </div>
          <div class="logotop bottom">
            <img
              src="https://wowsite.oss-cn-shenzhen.aliyuncs.com/public/uploads/course/logoweiba.png"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "goodCourse",
  data() {
    return {
      jpkdata: [],
    };
  },
  computed: {},
  components: {},
  methods: {
    getData() {
      var _t = this;
      _t.$API
        .getHelpsList({
          page: 1,
          page_size: 50,
        })
        .then((res) => {
          _t.jpkdata = res.data.list;
        });
    },
    goexternal(e) {
      // console.log(e)
      var _t = this;
      var origin_id = e.applets.origin_id;
      var weapp_path = e.applets.weapp_path;
      var u = navigator.userAgent;
      var isIos = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //IOS端
      var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1;
      if (!!isIos) {
        if (e.course.has_express == 0) {
          _t.$dialog.alert({
            message: `由于相关规范 IOS功能暂不可用`,
            confirmButtonText: "关闭",
            cancelButtonColor: "#07D1AA",
          });
          return;
        }
        let data = {
          origin_id: origin_id,
          weapp_path: weapp_path,
        };
        window.webkit.messageHandlers.buyCourseNow.postMessage({
          oneParam: data,
        });
      }
      if (!!isAndroid) {
        App.openMini(origin_id, weapp_path);
      }
    },
  },
  mounted() {
    this.getData();
  },
  created() {},
  beforecreate() {},
};
</script>
<style lang="scss" scoped>
.goodCourseBox {
  width: 100%;
  background: linear-gradient(180deg, #45daba, #4bdbbc);
}
.goodCourseHead {
  height: auto;
  margin: 0;
  padding: 0;
  overflow: hidden;
}
.goodCourseHead img {
  height: 100%;
}
.logotop {
  padding: 20px 0;
  text-align: center;
}
.logotop img {
  margin: 0 auto;
  width: 126px;
}
.zaixian {
  text-align: center;
}
.zaixian {
  margin: 0 auto;
  width: 226px;
  margin-bottom: 10px;
}
.ren {
  position: relative;
  width: 100%;
}
.ren img {
  width: 100%;
}
.centent {
  position: relative;
  margin-top: 22px;
}
.goodCoursejpb {
  width: 322px;
  margin: 0 auto;
  background: #fff;
  padding: 21px 13px;
  border-radius: 20px;
  margin-bottom: 24px;
}
.courseTitle {
  text-align: left;
  margin-bottom: 31px;
}
.courseTitle img {
  width: 77px;
}
.courseTitle.why {
  font-size: 20px;
  color: #41525b;
  position: relative;
}
.whytitle {
  text-align: center;
  font-weight: 500;
}
.courseTitle.why img {
  width: 33px;
  height: auto;
  position: absolute;
  left: 70px;
  top: -20px;
}
.jpCourse {
  margin-bottom: 17px;
}
.jpCourse:last-child {
  margin-bottom: 0;
}
.jpCouseSm {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.jpcover {
  width: 160px;
  height: 90px;
  border-radius: 8px;
  overflow: hidden;
}
.jpcover img {
  height: 100%;
  width: 100%;
  max-height: 90px;
}
.jpcontent {
  width: 145px;
  height: 90px;
  font-size: 14px;
  text-align: left;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.jptitle {
  font-size: 14px;
  line-height: 20px;
  height: 42px;
  overflow: hidden;
  color: #314643;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  white-space: normal;
}
.jpPirce {
  display: flex;
  margin-top: 6px;
  margin-bottom: 6px;
  align-items: center;
  font-size: 14px;
}
.jpPirce div:nth-of-type(1) {
  color: #fb6666;
  font-weight: bold;
}
.jpcontent .buynow {
  width: 80px;
  height: 22px;
  opacity: 1;
  background: linear-gradient(90deg, #ff8804, #fb6666);
  border-radius: 20px;
  color: #fff;
  font-size: 10px;
  line-height: 22px;
  text-align: center;
}
.buynow img {
  height: 100%;
  width: 100%;
}
.qa {
  background: #f6f6f6;
  padding: 0 13px;
  padding-top: 27px;
  padding-bottom: 36px;
  border-radius: 20px 20px 0px 0px;
}
.qabigtitle {
  text-align: center;
  width: 180px;
  margin: 0 auto;
  border-radius: 20px;
  text-align: center;
  font-size: 26px;
  font-weight: bold;
  color: #41525b;
  margin-bottom: 29px;
  font-family: PingFang SC, PingFang SC-Semibold;
}
.Qbox,
.Abox {
  display: flex;
  margin-bottom: 21px;
}
.Abox {
  margin-bottom: 27px;
}
.q,
.a {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #45daba;
  font-size: 14px;
  margin-right: 14px;
  line-height: 21px;
  text-align: center;
  color: #fff;
}
.a {
  background: #45daba;
}
.qtext,
.atext {
  color: #314643;
  font-size: 12px;
  max-width: 305px;
  text-align: left;
  line-height: 25px;
  font-weight: 400;
}
.logotop.bottom {
  padding: 0;
  margin-top: 36px;
}
</style>

